<script setup lang="ts">
import type { Profile } from '@ficpod/core-types'

defineProps<{
  profile?: Profile | null
  size?: 'default' | 'large' | 'small'
  showBadge?: boolean
}>()
</script>

<template>
  <div :class="['avatar', size === 'large' ? 'avatar--large' : '', size === 'small' ? 'avatar--small' : '']">
    <img 
      v-if="profile?.avatar_url"
      :src="profile.avatar_url"
      alt="Avatar"
      class="avatar__image"
    />
    <div v-else class="avatar__placeholder">
      {{ profile?.username?.charAt(0).toUpperCase() || 'U' }}
    </div>
    <span 
      v-if="showBadge && profile?.is_author"
      class="avatar__badge avatar__badge--author"
      title="Author"
    >
      <svg class="avatar__badge-icon" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </span>
    <span 
      v-else-if="showBadge"
      class="avatar__badge avatar__badge--reader"
      title="Reader"
    >
      <svg class="avatar__badge-icon" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.869 0 3.585.736 4.856 1.936A7.968 7.968 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.969 7.969 0 0014.5 4c-1.869 0-3.585.736-4.856 1.936A7.969 7.969 0 015.5 4c-1.255 0-2.443.29-3.5.804v10z" />
      </svg>
    </span>
  </div>
</template>
